/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' di convenzione della domanda esercente
 */
export enum ModalitaConvenzione {

    DIRETTA = 'DIRETTA',

    BANDO = 'BANDO',

    DOMANDA = 'DOMANDA'
}

